import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const RaffleListPage = lazyWithRetry(() =>
  import("@/features/raffle/pages/RaffleListPage").then((m) => ({ default: m.RaffleListPage })),
);
const RaffleDetailPage = lazyWithRetry(() =>
  import("@/features/raffle/pages/RaffleDetailPage").then((m) => ({ default: m.RaffleDetailPage })),
);

export const RAFFLES_PATH = "/raffles";
export const RAFFLE_DETAIL_PATH = `${RAFFLES_PATH}/:lotteryId`;

export const getRaffleDetailPath = (lotteryId: string) => `${RAFFLES_PATH}/${lotteryId}`;

const raffleRoutes: RouteConfig[] = [
  {
    path: RAFFLES_PATH,
    element: <RaffleListPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: RAFFLE_DETAIL_PATH,
    element: <RaffleDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default raffleRoutes;
